﻿import Cookies from 'js-cookie';

export class CookieStorage {
    constructor(options) {
        this.options = options;
    }

    getItem(key) {
        return Cookies.get(key);
    }

    setItem(key, value) {
        if (value)
            Cookies.set(key, value, this.options);
        else
            Cookies.remove(key);
    }
}